export default __webpack_public_path__ + "static/media/reporting-mac-demo.834da1d6.png";